module.exports = __webpack_public_path__ + "img/css-logo.ccf30a6c.png";